import {
  Button,
  makeStyles,
  Typography,
  Dialog,
  IconButton,
  FormControlLabel,
  Checkbox
} from '@material-ui/core/'
import PhoneIcon from '@material-ui/icons/Phone'
import { useState, Fragment, useCallback } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateApplicationPhoneShownByCode } from '../../actions/applications'
import { openDialog } from '../../actions/dialogs'
import { UpdateApplicationPhoneShownByCode } from '../../actions/types'
import Suggest from '../../containers/Apartment/Stepper/Steps/Suggest'
import customCloseIcon from '../../images/customCloseIcon.svg'
import i18n from '../../translations/i18n'
import { Application } from '../../types/applications'
import { StateInterface } from '../../types/states'
import TermsFrame from '../TernsFrame/TermsFrame'

const useStyles = makeStyles((theme) => ({
  phoneShow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.3rem',
    padding: '0.5rem'
  },
  phoneSvg: {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    paddingBottom: '4px',
    boxSizing: 'border-box',
    '& svg': {
      height: '15px',
      width: '15px'
    }
  },
  phoneNumber: {
    color: '#A2A4AF',
    fontSize: '1.1rem'
  },
  phoneNumberLink: {
    textDecoration: 'none',
    color: 'inherit'
  },
  hideBox: {
    display: 'flex',
    height: '1.4rem',
    width: '4ch',
    borderRadius: '2px',
    background:
      'repeating-linear-gradient(-60deg, #bbbbbb 0, #bbbbbb 2px, transparent 1px, transparent 5px)'
  },
  showButton: {
    background: '#e7e7e7',
    '&:hover': {
      background: '#d3d3d3'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none !important'
  },
  modalContainer: {
    borderRadius: '25px'
  },
  modalBody: {
    padding: '4.5rem',
    paddingTop: '3rem',
    background: '#ffffff',
    borderRadius: '10%',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'justify',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem'
    }
  },
  closeButton: {
    position: 'absolute',
    right: '0.5rem',
    top: '0.5rem',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  checkboxLabels: {
    alignItems: 'start',
    '& span': {
      fontFamily: 'CircularBold'
    }
  },
  checkboxes: {
    marginTop: '-10px',
    marginLeft: '0',
    marginRight: '0',
    '& label': {
      marginRight: '6px'
    }
  },
  agreeButton: {
    padding: '10px 0',
    borderRadius: '10px'
  },
  status: {
    color: '#fff',
    background: '#94004A',
    padding: '0.1rem 0.6rem',
    lineHeight: '20px',
    alignSelf: 'flex-end',
    marginTop: '24px',
    position: 'absolute' as const,
    right: '0',
    fontSize: '0.8rem',
    '&::before': {
      content: '""',
      position: 'absolute' as const,
      top: 0,
      left: '-14px',
      width: 0,
      height: 0,
      borderTop: '20px solid #94004A',
      borderLeft: '15px solid transparent'
    },
    '&::after': {
      content: '""',
      position: 'absolute' as const,
      bottom: 0,
      left: '-14px',
      width: 0,
      height: 0,
      borderBottom: '20px solid #94004A',
      borderLeft: '15px solid transparent'
    }
  },
  phoneLink: {
    color: '#A2A4AF',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}))

export interface PhoneShowProps {
  application: Application
  shown: boolean | undefined
  isAdmin: boolean | undefined
}

interface DispatchProps {
  updateApplicationPhoneShownByCode: UpdateApplicationPhoneShownByCode
  openDialog: (id: string) => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateProps { }

type ComponentProps = PhoneShowProps & StateProps & DispatchProps

const PhoneShow = (phoneShowProps: ComponentProps) => {
  const {
    application,
    shown,
    updateApplicationPhoneShownByCode,
    isAdmin,
    openDialog
  } = phoneShowProps

  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [checked, setChecked] = useState(false)
  const handleAgreeButton = useCallback(() => {
    if (application !== undefined) {
      application['phoneShown'] = true
      updateApplicationPhoneShownByCode(application)
      setOpen(false)
      handleClickOnPhone()
    }
  }, [application, updateApplicationPhoneShownByCode])
  const handleClickOnPhone = () => {
    if (application.status !== 'tenant' && application.status !== 'invitationsSent') {
      openDialog(`createViewingDirectly-${application.applicationId}`)
      if (!isAdmin && !shown) {
        updateApplicationPhoneShownByCode(application)
      }
    }
  }
  return (
    <Fragment>
      <>
        {!application.data.phone ? (
          <Typography
            variant='h6'
            style={{
              paddingLeft: '8px',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem'
            }}
          >
            {' '}
            <div className={classes.phoneSvg}>
              <PhoneIcon />
            </div>
            {i18n.t('application.noPhone')}
          </Typography>
        ) : (
          <div className={classes.phoneShow}>
            <div className={classes.phoneSvg}>
              <PhoneIcon />
            </div>
            {(isAdmin && shown) || application.status === 'invitationsSent' || application.status === 'tenant' ? (
              <>
                <Typography
                  className={classes.phoneNumber}
                  style={{ cursor: 'pointer' }}
                >
                  <a
                    href={`tel:+${application.data.phone}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                    onClick={() => handleClickOnPhone()}
                  >
                    +{application.data.phone}
                  </a>
                </Typography>
                {isAdmin && shown && (
                  <span className={classes.status}>
                    {' '}
                    {i18n.t('application.phone.viewed')}
                  </span>
                )}
              </>
            ) : (
              <>
                {' '}
                {isAdmin ? (
                  <Typography
                    className={classes.phoneNumber}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleClickOnPhone()}
                  >
                    +{application.data.phone}
                  </Typography>
                ) : (
                  <>
                  </>
                )}
              </>
            )}

            {!isAdmin && application.status !== 'invitationsSent' && application.status !== 'tenant' && (
              <>
                <Typography
                  className={classes.phoneNumber}
                  style={{ cursor: 'pointer' }}
                >
                  <a
                    //href={`tel:+${application.data.phone}`}
                    className={classes.phoneLink}
                    onClick={() => handleClickOnPhone()}
                  >
                    +{application.data.phone}
                  </a>
                </Typography>
                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  className={classes.modal}
                  PaperProps={{
                    style: {
                      borderRadius: '25px',
                      maxWidth: '800px'
                    }
                  }}
                >
                  <div className={classes.modalBody}>
                    <IconButton
                      aria-label='close'
                      className={classes.closeButton}
                      onClick={() => setOpen(false)}
                    >
                      <img src={customCloseIcon} alt='closeIcon' />
                    </IconButton>

                    <Suggest
                      containerMaxWidth='800px'
                      contentMaxWidth='800px'
                      content={i18n.t('application.phone.modalText')}
                      isModal
                    />

                    <TermsFrame createdAt={application.createdAt} />
                    <FormControlLabel
                      className={classes.checkboxLabels}
                      control={
                        <Checkbox
                          className={classes.checkboxes}
                          checked={checked}
                          onChange={() => setChecked(!checked)}
                        />
                      }
                      label={i18n.t('application.phone.checkBox')}
                    />
                    <Button
                      disabled={!checked}
                      variant='contained'
                      color='primary'
                      onClick={handleAgreeButton}
                      className={classes.agreeButton}
                    >
                      {i18n.t('application.phone.agree')}
                    </Button>
                  </div>
                </Dialog>
              </>
            )}
          </div>
        )}
      </>
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => ({})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateApplicationPhoneShownByCode: (application: Application) =>
    dispatch(updateApplicationPhoneShownByCode(application)),
  openDialog: (id: string) => dispatch(openDialog(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(PhoneShow)
